<template >
  <div class="text-xs-center">
    <v-menu
      :close-on-content-click="true"
      :nudge-width="100"
      max-width ="220px"
      v-model="menu"
      offset-x
    >
    	<!-- <v-btn slot="activator"  flat color="primary">Primary</v-btn> -->
    	<div slot="activator" >
        	<span flat  class="p_money">{{money}}</span>
        	<v-badge color="pink" v-if="item.save_num > 0">
		      <span slot="badge">{{item.save_num}}</span>
		      <v-icon  color="red" class="iconfont">icon-save1</v-icon>
		    </v-badge>
		   	<del class="p_less" v-if="item.less>0"> {{item.less.toFixed(2)}}</del>
        </div>


      <v-card>
		<v-layout row justify-space-around>
			<v-flex xs6>
				<v-btn  small   color="success" @click.native="my_prompt_input('count')">数量</v-btn>
			</v-flex>
			<v-flex xs6>
				<v-btn depressed small  color="info" @click.native="my_prompt_input('price')">自定价</v-btn>
			</v-flex>
		</v-layout>
		<v-divider ></v-divider>

		<v-layout row justify-space-around>
			<v-flex xs4 d-flex ><v-btn depressed small color="warning" @click.native="my_prompt_input('discount')">折扣</v-btn></v-flex>
			<v-flex xs4 d-flex><v-btn depressed small color="light-blue lighten-4"@click="set_discount(100)">无折</v-btn></v-flex>
			<v-flex xs4 d-flex><v-btn depressed small color="light-green lighten-3" @click="use_vip_price()">会员</v-btn></v-flex>
		</v-layout>

		<v-layout row justify-space-around>
			<v-flex xs4><v-btn depressed small color="info" @click.native="free_it()">赠送</v-btn></v-flex>
			<v-flex xs4><v-btn depressed small color="success" @click.native="my_prompt_input('less')">减免</v-btn></v-flex>
			<v-flex xs4><v-btn depressed small color="purple lighten-4" @click.native="set_to_int()">抹零</v-btn></v-flex>
		</v-layout>

		<v-divider ></v-divider>
		<v-layout row justify-space-around>
			<v-flex xs3><v-btn depressed small color="light-green lighten-3" @click="set_discount(90)">90</v-btn></v-flex>
			<v-flex xs3><v-btn depressed small color="light-blue lighten-3" @click="set_discount(88)">88</v-btn></v-flex>
			<v-flex xs3><v-btn depressed small color="warning" @click="set_discount(85)">85</v-btn></v-flex>
			<v-flex xs3><v-btn depressed small color="success" @click="set_discount(80)">80</v-btn></v-flex>
		</v-layout>

		<v-layout row justify-space-between>
			<v-flex xs3><v-btn depressed small color="lime lighten-3" @click="set_discount(75)">75</v-btn></v-flex>
			<v-flex xs3><v-btn depressed small color="warning" @click="set_discount(70)">70</v-btn></v-flex>
			<v-flex xs3><v-btn depressed small color="info" @click="set_discount(61)">61</v-btn></v-flex>
			<v-flex xs3><v-btn depressed small color="primary" @click="set_discount(50)">半</v-btn></v-flex>
		</v-layout>

        <div>
        	<v-divider ></v-divider>
	        <v-layout row justify-space-between>
				<v-flex xs4><v-btn depressed small color="warning">库存</v-btn></v-flex>
				<v-flex xs4><v-btn depressed small color="orange lighten-1" @click.native="return_it()">退货</v-btn></v-flex>
				<v-flex xs4><v-btn depressed small color="error" @click="delete_it()">删除</v-btn></v-flex>
			</v-layout>	
		</div>
		<div v-if="vip.mobile">
			<v-divider ></v-divider>
			<v-layout row justify-space-between>
				<v-flex xs12><v-btn depressed small color="success" @click="set_to_ems()">直邮</v-btn></v-flex>
			</v-layout>
		</div>

		<div v-if="vip.mobile">
			<v-divider ></v-divider>
			<v-layout row justify-space-between>
				<v-flex xs4>
					<v-btn  dark small color="warning" @click.stop="inc_save(-1)">
		              <v-icon dark>ti-minus</v-icon>
		            </v-btn>
				</v-flex>
				<v-flex xs4>
					<span class='save_count'><small>存</small>{{item.save_num}}</span>
				</v-flex>
				<v-flex xs4>
					<v-btn  dark small color="success" @click.stop="inc_save(1)">
		              <v-icon dark class="iconfont">icon-plus</v-icon>
		            </v-btn>
				</v-flex>
			</v-layout>
		</div>

		<v-layout row justify-space-between>
			<v-flex xs12><v-btn depressed small color="pink" @click="print_lable(item)">打印标签</v-btn></v-flex>
		</v-layout>

	</v-card>
    </v-menu>

	
  </div>   
</template>

<script>
import msgpad_show from "../../../msgpad_show"
import mix_sale_item from '../mixin/mix_sale_item'
import prompt_dlg from '../mixin/mix_prompt_dlg'
import axios from 'axios'



var valid_check_info = {
    "less": {
        title: "请输入减免金额",
        remind: "减免金额不能大于商品售价",
        regexp: /^([0-9]*\.?[0-9]+)$/,
    },
    "price": {
        title: "请输入自定义金额",
        remind: "只能输入0-9及小数点",
        regexp: /^([0-9]*\.?[0-9]+)$/,
    },
    "discount": {
        title: "请输入折扣值0-100",
        remind: "只能输入0-100",
        regexp: /^[0-9]*$/,
        rang: [0, 100]
    },
    "count": {
        title: "请输入商品数量",
        remind: "数量不能为负数，仅能为数字",
        regexp: /^[0-9]*$/,
        rang: [0, 1000]
    },
    "weight":{
        title: "请输入商品重量",
        remind: "只能输入0-9及小数点",
        regexp: /^([0-9]*\.?[0-9]+)$/,
    }
}


export default {
    //template:``,
    name: '',
    mixins:[mix_sale_item,prompt_dlg],
    props:{
    	item:Object,
    	// isfinished:Number,
    	action:Function,
    },
    computed:{},
    methods:{

    	my_prompt_input(cmd){
    		debugger
    		if(this.isfinished) {this.msgpad_show("msgpad","ERROR",'本单已经结算','error');return};
    		if (valid_check_info[cmd]) {
		        var cmd_oper = valid_check_info[cmd];
		        var rang = cmd_oper.rang;
		    	this.prompt_dlg(cmd_oper.title,cmd_oper.title,cmd,(value,self)=>{
	    			if(cmd_oper.regexp.test(value)){
	    				if (!rang) return true;
	    				if(rang && 1 * value >= rang[0] && 1 * value <= rang[1]){
	    					return true;
	    				}
	    				// debugger
	    				return false;
	    			}
	    			return false;
		    	}).then(value=>{
		    		console.log("input :",value);
		    		value *= 1;
		    		if(cmd == 'count')    return this.set_number(value);
		    		if(cmd == 'less')     return this.less_money(value);
		    		if(cmd == 'price')    return this.set_real_price(value);
		    		if(cmd == 'discount') return this.set_discount(value);
		    		if(cmd == 'weight')   return this.set_number(value);
		    	}).catch(err=>{
		    		console.log('reject:',err);
		    	})
		    } 
    	},
    	print_lable(item){
    		axios.post("http://localhost:3000/print/lable",item).then(doc=>{
    			debugger
    		}).catch(err=>{

    		})
    	}
    	
    },
    components:{},
    watch:{},
    directives: {},
    mounted :function(){},
    data () {
      return {
      	menu:false
      }
    },
    filters: {
      //pluralize: (n, w) => n === 1 ? w : (w + 's'),
      capitalize: s => s.charAt(0).toUpperCase() + s.slice(1)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.menu__content{
    max-width: 200px;
}
.p_money{
  font-size: 25px;
  font-weight: bold;
  color: #3486D7;
}
.p_less{
   display: block;

	font-weight: bold;
	color: red;
}
.flex > button{
	min-width: 40px;
	font-size: 18px;
}
.xs12  button{
	width: 94%
}
.xs6 button{
	width: 90%
}
hr.divider {
	margin: 5px 0;
}

.save_count{
	font-size: 25px;
	color: #3486D7;
	font-weight: bold;
	margin:auto; display:table;
}

</style>



// WEBPACK FOOTER //
// src/views/front_sale/components/oper_menu.vue